import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { KeyVaultService } from '../../../service/key-vault.service';

@Injectable({
  providedIn: 'root'
})
export class CoreApiService {

  API_M_URL: string;

  private initialization: Promise<void> | null = null;

  constructor(private readonly http: HttpClient, private readonly keyVaultService: KeyVaultService) { }

  initializeAPIUrl(): Promise<void> {
    if (this.API_M_URL) {
      return Promise.resolve();
    }

    const resolvedUrl = this.keyVaultService.apimUrl;
    if (resolvedUrl) {
      this.API_M_URL = resolvedUrl;
      return Promise.resolve();
    }

    this.initialization ??= this.resolveApimUrl();
    return this.initialization;
  }

  private resolveApimUrl(): Promise<void> {
    // apimUrl$ only emits after the vault bootstrap has run; on a deep link that
    // skipped product selection nothing has triggered it, so start it here.
    this.keyVaultService.loadSecrets().subscribe({ error: () => { } });

    return firstValueFrom(this.keyVaultService.apimUrl$)
      .then(url => {
        this.API_M_URL = url;
      })
      .catch(err => {
        this.initialization = null;
        throw err;
      });
  }
}
